"use client";
import { IBlocks, IUserData } from "@/types";
import React from "react";
import CardSetting from "@/components/admin/settings/CardSetting";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
interface Props {
    account: IUserData;
    block: IBlocks;
    blockUpdate: React.Dispatch<React.SetStateAction<IBlocks>>;
    update: (value: IBlocks) => void;
}

export default function BlogPostLatestOptions({
    account,
    block,
    blockUpdate,
    update,
}: Props) {
    const [oldBlock, setOldBlock] = React.useState(block);
    const [title, setTitle] = React.useState(block.name);
    return (
        <CardSetting noBorder>
            <div className="border-3 flex w-full flex-col gap-3 border-white">
                <div className="relative flex w-full flex-col gap-4">
                    <Input
                        label="Title"
                        id="title"
                        value={title}
                        onChange={(e) => {
                            setTitle(e.target.value);
                            blockUpdate({
                                ...block,
                                name: e.target.value,
                            });
                        }}
                        onBlur={(e) => {
                            if (oldBlock.name !== e.target.value) {
                                setOldBlock({
                                    ...oldBlock,
                                    name: e.target.value,
                                });
                                update({
                                    ...block,
                                    name: e.target.value,
                                });
                            }
                        }}
                    ></Input>
                </div>
            </div>
        </CardSetting>
    );
}
